import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';

const CryptoForm = () => {
  const [form] = Form.useForm();
  const [cryptoData, setCryptoData] = useState({});

  const onFinish = (values) => {
    setCryptoData(values);
  };

  return (
    <Form
      form={form}
      name="crypto_form"
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Form.Item
        label="Cryptocurrency"
        name="cryptocurrency"
        rules={[
          {
            required: true,
            message: 'Please input the cryptocurrency you want to trade!',
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Amount"
        name="amount"
        rules={[
          {
            required: true,
            message: 'Please input the amount of cryptocurrency you want to trade!',
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Price"
        name="price"
        rules={[
          {
            required: true,
            message: 'Please input the price of the cryptocurrency you want to trade!',
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CryptoForm;